export const uk = {
    'common-price-editor-description-phrases':
        'Ставка за тысячу показов, которую вы установите, будет использоваться для всех фраз',
    'common-price-editor-description-retargetings':
        'Ставка за клик, которую вы установите, будет использоваться для всех условий показа',
    'common-price-editor-description-users-profile':
        'Ставка за тысячу показов, которую вы установите, будет использоваться для всех условий показа',
    'common-price-editor-title': 'Единая ставка',
    'common-price-editor-title-phrases': 'Единая ставка для фраз',
    'common-price-editor-title-retargetings': 'Единая ставка для ретаргетингов и подбора аудитории',
    'common-price-editor-title-users-profile': 'Единая ставка для профилей пользователей',
    'selected-phrases': {
        one: 'Выбрана {count} фраза',
        some: 'Выбрано {count} фразы',
        many: 'Выбрано {count} фраз',
        none: 'Выбрано {count} фраз'
    },
    'selected-retargetings': {
        one: 'Выбрано {count} условие',
        some: 'Выбрано {count} условия',
        many: 'Выбрано {count} условий',
        none: 'Выбрано {count} условий'
    },
    'set-cpc-price': 'Назначить единую ставку за клик',
    'set-cpm-price': 'Назначить единую ставку за тысячу показов',
    'set-price': 'Назначить единую ставку',
    'single-rate-max-price': 'Единая ставка не должна быть больше {maxValue} {currency}',
    'single-rate-min-price': 'Единая ставка не должна быть меньше {minValue} {currency}'
};
